import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';

import { Debt, DebtService, Offer } from '../../../core/data';

@Component({
  selector: 'app-offers',
  templateUrl: './offers.component.html',
})
export class OffersComponent implements OnChanges {
  @Input() debt: Debt;
  @Output() onChange = new EventEmitter<Offer>();
  offers: Offer[];

  constructor(private debtService: DebtService) {}

  ngOnChanges() {
    this.debtService
      .offers(this.debt)
      .map(offers => {
        offers.forEach(offer => offer['length'] = Math.ceil(offer.frequency * offer.periods / 30));
        return offers;
      })
      .subscribe(offers => this.offers = offers);
  }

  select(index: number) {
    this.onChange.emit(this.offers[index]);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/plans/offers.component.ts